// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3_vFf","dragIcon":"Choice_dragIcon__2LBsD","left":"Choice_left__2maBX","input":"Choice_input__2Hgm6"};